import * as actionTypes from "./actionTypes";

const initialState = {
  userId: null,
  email: null,
  verified: null,
  purchased: [],
  showSettingsModal: false,
  showPasswordResetModal: false,
  currentCategory: "All Prompts",
  mailchimpTags: [],
  includeNSFW: false,
};

const authUpdateState = (state, action) => {
  if (!action.authData) {
    return {
      ...state,
      userId: null,
      email: null,
      verified: null,
      includeNSFW: false,
    };
  }
  return {
    ...state,
    userId: action.authData.uid,
    email: action.authData.email,
    verified: action.authData.emailVerified,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_UPDATE_STATE:
      return authUpdateState(state, action);
    case actionTypes.UPDATE_PURCHASED:
      return { ...state, purchased: action.purchased };
    case actionTypes.SET_SETTINGS_MODAL:
      return { ...state, showSettingsModal: action.show };
    case actionTypes.SET_PASSWORD_RESET_MODAL:
      return { ...state, showPasswordResetModal: action.show };
    case actionTypes.SET_CURRENT_CATEGORY:
      return { ...state, currentCategory: action.category };
    case actionTypes.SET_MAILCHIMP_TAGS:
      return { ...state, mailchimpTags: action.tags };
    case actionTypes.SET_INCLUDE_NSFW:
      return { ...state, includeNSFW: action.include };
    default:
      return state;
  }
};

export default reducer;
